 $('.js-styleguidetoggle').on('click', function(e){
 	const $el = $(this)

 	$el.closest('.styleguide__group').find('.styleguide__group__in').toggle()

  e.preventDefault()
})
